import React from "react"
import { Flex } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import placeholderImage from "assets/images/placeholder-image.svg"
import EventVideoOrImage from "./EventVideoOrImage"
import { PREVIEW_PADDING } from "../../PreviewFrameWithBranding/PreviewFrameWithBranding"

type Props = {
  event: DioboxEvent
}

const EventImageAndVideo = ({
  event: {
    portalShowEventImage,
    portalShowEventVideo,
    portalEventVideoUrl,
    portalEventImageUrl,
    portalEventImageScale,
  },
}: Props) => {
  const eventImageUrl = portalEventImageUrl ? `${portalEventImageUrl}?w=1400&h=1050` : placeholderImage

  return (
    <Flex px={PREVIEW_PADDING}>
      <Flex
        w="100%"
        borderWidth={1}
        borderBottomWidth={0}
        borderTopRadius="lg"
        alignItems="center"
        flexDirection="column"
        pb={4}
        backgroundColor="white"
      >
        <Flex w="full" borderTopRadius="lg" overflow="hidden" justifyContent="center">
          <EventVideoOrImage
            portalShowEventImage={portalShowEventImage}
            portalShowEventVideo={portalShowEventVideo}
            portalEventVideoUrl={portalEventVideoUrl}
            eventImageUrl={eventImageUrl}
            portalEventImageUrl={portalEventImageUrl}
            portalEventImageScale={portalEventImageScale}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default EventImageAndVideo
